import DT from '@repo/alt/DependencyTypes'
import { inject, injectable } from 'inversify'
import type {
  Router,
  RouteLocationRaw,
  LocationAsRelativeRaw,
} from 'vue-router'

import { navigateTo } from '#app'

export type RoutingServiceRouteData = {
  name: string
  route: string
  go: () => void
}

@injectable()
export class RoutingService {
  constructor(
    @inject(DT.Router) readonly router: Router,
  ) {}

  push(route: RouteLocationRaw) {
    return this.router.push(route)
  }

  localeRoute(route: RouteLocationRaw) {
    return this.router.resolve(route).fullPath
  }

  createRouteData(route: LocationAsRelativeRaw & { name: string, query?: Record<string, string | undefined> }): RoutingServiceRouteData {
    const localeRoute = this.localeRoute(route)

    return {
      name: route.name,
      route: localeRoute,
      go: () => this.push(localeRoute),
    }
  }

  externalRedirect(path: string) {
    if (import.meta.server) {
      return
    }

    return navigateTo(path, { external: true })
  }
}
